export default __webpack_public_path__ + "static/media/Snd_TryM.63fd99cf.mp3";